import { useState, useEffect } from 'react';

// Borrowed from https://usehooks.com ♥️
function useWindowSize() {
    var isClient = typeof window === 'object';
    function getSize() {
        return {
            width: isClient ? window.innerWidth : undefined,
            height: isClient ? window.innerHeight : undefined
        };
    }
    var _a = useState(getSize), windowSize = _a[0], setWindowSize = _a[1];
    useEffect(function () {
        if (!isClient) {
            return false;
        }
        function handleResize() {
            setWindowSize(getSize());
        }
        window.addEventListener('resize', handleResize);
        return function () { return window.removeEventListener('resize', handleResize); };
    }, []); // Empty array ensures that effect is only run on mount and unmount
    return windowSize;
}

function useOverflow(ref) {
    var _a = useState(false), refXOverflowing = _a[0], setRefXOverflowing = _a[1];
    var _b = useState(false), refYOverflowing = _b[0], setRefYOverflowing = _b[1];
    var _c = useState(true), refXScrollBegin = _c[0], setRefXScrollBegin = _c[1];
    var _d = useState(false), refXScrollEnd = _d[0], setRefXScrollEnd = _d[1];
    var _e = useState(true), refYScrollBegin = _e[0], setRefYScrollBegin = _e[1];
    var _f = useState(false), refYScrollEnd = _f[0], setRefYScrollEnd = _f[1];
    var size = useWindowSize();
    useEffect(function () {
        if (!(ref === null || ref === void 0 ? void 0 : ref.current)) {
            return;
        }
        var isXOverflowing = ref.current.scrollWidth > ref.current.clientWidth;
        var isYOverflowing = ref.current.scrollHeight > ref.current.clientHeight;
        if (refXOverflowing !== isXOverflowing) {
            setRefXOverflowing(isXOverflowing);
        }
        if (refYOverflowing !== isYOverflowing) {
            setRefYOverflowing(isYOverflowing);
        }
        var handleScroll = function () {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            // Handle X Overflow
            var offsetRight = ((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.scrollWidth) - ((_b = ref === null || ref === void 0 ? void 0 : ref.current) === null || _b === void 0 ? void 0 : _b.clientWidth);
            if (((_c = ref === null || ref === void 0 ? void 0 : ref.current) === null || _c === void 0 ? void 0 : _c.scrollLeft) >= offsetRight && refXScrollEnd === false) {
                setRefXScrollEnd(true);
            }
            else {
                setRefXScrollEnd(false);
            }
            if (((_d = ref === null || ref === void 0 ? void 0 : ref.current) === null || _d === void 0 ? void 0 : _d.scrollLeft) === 0) {
                setRefXScrollBegin(true);
            }
            else {
                setRefXScrollBegin(false);
            }
            // Handle Y Overflow
            var offsetBottom = ((_e = ref === null || ref === void 0 ? void 0 : ref.current) === null || _e === void 0 ? void 0 : _e.scrollHeight) - ((_f = ref === null || ref === void 0 ? void 0 : ref.current) === null || _f === void 0 ? void 0 : _f.clientHeight);
            if (((_g = ref === null || ref === void 0 ? void 0 : ref.current) === null || _g === void 0 ? void 0 : _g.scrollTop) >= offsetBottom && refYScrollEnd === false) {
                setRefYScrollEnd(true);
            }
            else {
                setRefYScrollEnd(false);
            }
            if (((_h = ref === null || ref === void 0 ? void 0 : ref.current) === null || _h === void 0 ? void 0 : _h.scrollTop) === 0) {
                setRefYScrollBegin(true);
            }
            else {
                setRefYScrollBegin(false);
            }
        };
        ref.current.addEventListener('scroll', handleScroll);
        return function () { var _a; return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('scroll', handleScroll); };
    }, [ref, size.width]); // Empty array ensures that effect is only run on mount and unmount
    return {
        refXOverflowing: refXOverflowing,
        refYOverflowing: refYOverflowing,
        refXScrollBegin: refXScrollBegin,
        refXScrollEnd: refXScrollEnd,
        refYScrollBegin: refYScrollBegin,
        refYScrollEnd: refYScrollEnd,
    };
}

export { useOverflow };
//# sourceMappingURL=index.es.js.map
